/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ContentAlert} from '../models/ContentAlert';
import type {Error} from '../models/Error';

export interface GetSavedContentGeneralAlert$Request {
    requestBody: Array<string>;
}

export interface GetSavedContentGeneralAlert$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedContentGeneralAlertRequest = createAction<PayloadData<void, GetSavedContentGeneralAlert$Request>>('SAVED_CONTENT_ALERT__GET_SAVED_CONTENT_GENERAL_ALERT__REQUEST');
export const getSavedContentGeneralAlertSuccess = createAction<PayloadData<Array<ContentAlert>, GetSavedContentGeneralAlert$Request>>('SAVED_CONTENT_ALERT__GET_SAVED_CONTENT_GENERAL_ALERT__SUCCESS');
export const getSavedContentGeneralAlertFailure = createAction<PayloadData<Error, GetSavedContentGeneralAlert$Request, true>>('SAVED_CONTENT_ALERT__GET_SAVED_CONTENT_GENERAL_ALERT__FAILURE');

export const getSavedContentGeneralAlertActions = [
    getSavedContentGeneralAlertRequest,
    getSavedContentGeneralAlertSuccess,
    getSavedContentGeneralAlertFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedContentGeneralAlert = (meta: GetSavedContentGeneralAlert$Request, config?: GetSavedContentGeneralAlert$Config) => {
    return {
        CALL_API: {
            types: getSavedContentGeneralAlertActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/saved-contents/alerts`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

